import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import { HatGlasses } from "lucide-react";

import useAccountMetadata from "@/hooks/useAccountMetadata";
import { masqueradeToken, userIsFPEmployee } from "@/util";
import { ActiveOverridesInfo } from "./ActiveOverridesInfo";

type MasqueradeMenuItemProps = {
  onNavigate: () => void;
};

export const MasqueradeMenuItem = ({ onNavigate }: MasqueradeMenuItemProps) => {
  const accountMetadata = useAccountMetadata();

  if (
    !userIsFPEmployee() ||
    accountMetadata?.config?.disableMasqueradeWarningBanner
  ) {
    return null;
  }

  const masquerading = masqueradeToken() !== null;

  return (
    <div className="flex items-center gap-1">
      <RouterLink
        to="/masquerade"
        onClick={onNavigate}
        className="flex flex-1 cursor-pointer items-center gap-2 rounded-md p-2 hover:bg-gray-100 focus:bg-gray-100"
      >
        <span
          className={clsx("flex-shrink-0", masquerading && "text-status-error")}
        >
          <HatGlasses size={18} />
        </span>
        <span
          className={clsx(
            "block no-underline",
            masquerading ? "text-status-error" : "text-textDefault",
          )}
        >
          {masquerading ? "Masquerading" : "Masquerade"}
        </span>
      </RouterLink>
      {masquerading && (
        <ActiveOverridesInfo className="text-status-error hover:bg-gray-100 focus:bg-gray-100" />
      )}
    </div>
  );
};
